import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7906975d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radio-group" }
const _hoisted_2 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.possibleValues, (v) => {
      return (_openBlock(), _createBlock($setup["TableauRadioButton"], {
        key: v.value,
        groupName: $setup.groupName,
        value: v.value,
        modelValue: $props.modelValue,
        "onUpdate:modelValue": ($event: any) => ($setup.emits('update:modelValue', v.value)),
        disabled: v.disabled || $props.allDisabled,
        text: v.text
      }, null, 8 /* PROPS */, ["groupName", "value", "modelValue", "onUpdate:modelValue", "disabled", "text"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}